package co.maytes.standupbot.dashboard.components.widgets

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.styles.Palette
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.silk.components.text.SpanText

/**
 * Prompt-style quotation — leading `>` in the accent color, mono body. Used
 * when surfacing short, meaningful text from the system (a standup excerpt,
 * a testimonial, an operator note). The marker makes the quote feel like a
 * terminal echo rather than a pull-quote.
 */
@Composable
fun MonoQuote(
    text: String,
    modifier: Modifier = Modifier,
) {
    Box(
        modifier = Modifier
            .classNames("sb-mono-quote")
            .color(Palette.textPrimary)
            .then(modifier),
    ) {
        SpanText(text = text)
    }
}
